// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2eb3T","title":"Info_title__1SU5d","links":"Info_links__17KJe","link":"Info_link__2bXcr","logo":"Info_logo__2_nuP"};